import React, { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUndoAlt } from '@fortawesome/free-solid-svg-icons';
import Rng6Dice from './Rng6Dice';
import RngCoin from './RngCoin';
import { useGame } from '../context/GameContext';

function Menu(props: any) {
    const { reset, clearReset, triggerReset } = useGame();

    useEffect(() => {
      if (reset === true) {
        clearReset();
      }
    });

    return(
      <div className="responsive-menu">
        <Rng6Dice/>
        <RngCoin/>
        <FontAwesomeIcon
          icon={faUndoAlt} 
          onClick={() => { triggerReset(); }}
          className="App-icon"
        />
      </div>
    );
  }
  export default Menu;
